/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".Titulo[_ngcontent-%COMP%]{margin-top:150px;display:flex;justify-content:center;color:#005ab8;font-size:40px}@media (max-width:500px){.Titulo[_ngcontent-%COMP%]{font-size:24px}}"];
export { styles as styles };
